export type UiMode = 'legacy' | 'prd';

// PRD v3 cleanup: BackendMode removed - always use HTTP client (no mock mode)

export const uiMode: UiMode =
  (import.meta.env.VITE_UI_MODE as UiMode | undefined) ?? 'prd';

/**
 * Base URL for the backend (no trailing slash).
 *
 * - If set, we will call `${VITE_API_BASE_URL}/api/...`
 * - If empty/unset, we will call same-origin `/api/...`
 *
 * Phase 7 SWA Linked Backend: empty is now the EXPECTED value in PRD —
 * SWA proxies /api/* to the linked bennie-api backend, making the
 * cookie first-party and bypassing third-party cookie blocking in
 * private/incognito browsing.
 */
export const backendBaseUrl: string = (() => {
  const raw = import.meta.env.VITE_API_BASE_URL as string | undefined;
  if (!raw) {
    return '';
  }
  return raw.replace(/\/$/, '');
})();



